var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('div',[_c('small',{staticClass:"text-italic text-justified"},[_vm._v(_vm._s(_vm.project.info_for_participants))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }